module.exports = __webpack_public_path__ + "img/copy.55431c37.svg";